<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">Blood, Guts and Gore</h1>
<p class="subtitle">Assistant Surgeon John Gordon Smith in the Waterloo Campaign</p>
<p class="author">Edited by Gareth Glover</p>
<div class="img_containerp">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?12d920d0